<template>
  <div>
    <v-data-table
      :headers="headers ? headers : originHeaders"
      mobile-breakpoint="0"
      :items="studentAttendances"
      :server-items-length="totalItems"
      :items-per-page="10"
      :options.sync="pagination"
      item-key="id"
      loading-text="Đang Tải"
      :loading="loading"
      :footer-props="footerTable"
      sort-by="title"
      no-data-text="Không có dữ liệu"
      disable-sort
    >
      <template v-slot:item.student="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:item.class="{ item }">
        {{ item.student.currentClass ? item.student.currentClass.title : '' }}
      </template>
      <template v-slot:item.status="{ item }">
        <div>
          <v-chip small label :color="item.status | getAttendanceStatusColor" dark>
            <span class="mr-1">
              {{ item.status | getBusStudentAttendanceStatus }}
            </span>
            <span>{{ getTimeStatus(item) }} </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:item.busTimeline="{ item }">
        {{ item.bus_schedule | getBusTimeline }}
      </template>
      <template v-slot:item.action="{ item }">
        <BusStudentAttendanceListActions :studentTrackingId="item.id" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BusStudentAttendanceListActions from '@/modules/bus/BusStudentAttendanceListActions.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  components: { BusStudentAttendanceListActions, CardStudentName },
  data() {
    return {
      filtered: false,
      pagination: {},
      originHeaders: [
        { text: 'Học sinh', value: 'student', width: '20%' },
        { text: 'Lớp', value: 'class', width: '10%' },
        { text: 'Tuyến xe', value: 'bus.name', width: '20%' },
        { text: 'Chiều di chuyển', value: 'busTimeline', width: '20%' },
        { text: 'Trạng thái', value: 'status', width: '20%' },
        { text: 'Thao tác', value: 'action', width: '10%' }
      ]
    }
  },
  props: {
    headers: { type: Array, default: () => null },
    student: { type: Object, default: () => {} }
  },
  computed: {
    ...mapState('BusStudentAttendance', ['pageText', 'totalItems', 'studentAttendances', 'loading', 'date']),
    ...mapGetters('BusStudentAttendance', ['attendances', 'busTimeline']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'items-per-page-options': [5, 10, 15],
        'page-text': this.pageText
      }

      return footer
    }
  },
  methods: {
    ...mapActions('BusStudentAttendance', ['getStudentTrackingByPagination']),
    getTimeStatus(item) {
      if (item.status === 'attendance') {
        return item.timeCheckIn ? ' - ' + moment(Number.parseInt(item.timeCheckIn)).format('LT') : ''
      } else if (item.status === 'left') {
        return item.timeCheckOut ? ' - ' + moment(Number.parseInt(item.timeCheckOut)).format('LT') : ''
      } else return ''
    }
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.getStudentTrackingByPagination({ page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  border-bottom: 1px solid lightgray;
}
</style>
